import {Component, Input, OnInit} from '@angular/core';
import {WdrAllgemeinBericht} from "../../../../../../../model/vorhersagen/wdr-wetterbericht";

@Component({
  selector: 'app-wdr-deutschland-nordwest-bericht',
  templateUrl: './wdr-deutschland-nordwest-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class WdrDeutschlandNordwestBerichtComponent {

  @Input() deutschlandNordWestBericht: WdrAllgemeinBericht;



}
